import React from "react";
import classNames from "classnames";

import Icon from "../../../../assets/icon_config";
import WordOverflowTooltip from "@components/wordOverflowTooltip/WordOverflowTooltip";

export const PercentageNormal = (props: any) => {
    const _percentage = props.percentage ? props.percentage : 0;
    const percentClassName = classNames(
        "ui-population-insight__percentage",
        {
            "ui-population-insight__percentage--ngtv": _percentage >= 0,

            "ui-population-insight__percentage--pstv": _percentage < 0,

        }
    );

    let iconName;
    iconName = _percentage >= 0 ? "arrowUpFilled" : "arrowDownFilled";

    return (
        <div className={percentClassName}>
            <Icon name={iconName} />
            <WordOverflowTooltip text={(_percentage + ' %').replace('-','')}/>
        </div>
    );
};